<!-- <p>user-list works! {{item}}</p> -->
<main  class="middle-content">
    <div class="page_title_block">
        <h1 class="page_title">User Post Management</h1>
    </div>
    <div class="content-section">
        <div class="outer-box">
            <div class="global-table no-radius p0">
                <div class="tab-content1">

                            <div class="tab-pane1">
                                <div class="sec_head_new sec_head_new_after">

                                    <form [formGroup]="searchForm">
                                        <div class="row align-items-center">
                                            <div class="col-md-3 pr-0">
                                                <div class="filter_search mb20 width100">
                                                    <label class="d-flex align-items-center">Search:</label>
                                                    <div class="input-group filter_search_group">
                                                        <input type="text" class="form-control overflow-text" formControlName="search" placeholder="Search by name/username" maxlength="60">
                                                        <div class="input-group-append">
                                                            <button class="btn btn_search_group"><img src="assets/img/icon-search.png" (click)="search()"  alt="Search"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 pr-0">
                                                <label class="d-flex align-items-center">From Date:</label>
                                                <input type="date" class="form-control mb20" formControlName="fromDate" [max]="today" > 
                                            </div>
                                            <div class="col-md-2 pr-0">
                                                <label class="d-flex align-items-center">To Date:</label>
                                                <input type="date" formControlName="toDate" [readonly] = "!this.searchForm.controls['fromDate'].value" [min]="this.searchForm.controls['fromDate'].value" class="form-control mb20">
                                            </div>
                                            <div class="col-md-5">
                                                <div class="text-center admin-btn mb2 mt10 buttonGroup">
                                                    <button type="button" class="btn btn-theme" (click)="search()">Search</button>
                                                    <button type="button" class="btn btn-theme" (click)="reset()">Reset</button>
                                                    <button type="button" class="btn btn-theme btn-export" (click)="exportAsXLSX()">EXPORT TO EXCEL</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="table-responsive" style="margin-bottom: 30px;">
                                <table class="table table-striped table-bordered table-hover kv-grid-table kv-table-wrap" aria-describedby="user management list">
                                    <thead class="thead">
                                        <tr class="no_wrap_th text-center">
                                            <th scope="col" class="Sorting-img heading1">S.No</th>
                                            <th scope="col" class="Sorting-img">Name</th>
                                            <th scope="col" class="Sorting-img">Username</th>
                                            <th scope="col" class="Sorting-img">Email Address</th>
                                            <!-- <th scope="col" class="Sorting-img">Contact Number</th> -->
                                            <th scope="col" class="Sorting-img">Created Date & Time</th>
                                            <th scope="col" class="Sorting-img">Status</th>
                                            <th scope="col" class="action_td_btn3 Sorting-img heading2">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center" *ngFor="let item of customerData | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems}; let i = index">
                                            <td>{{itemsPerPage * (currentPage - 1) + i+1}}</td>
                                            <td class="content">{{item?.userDetails?.fullName || "--"}}</td>
                                            <td class="content">{{item?.userDetails?.userName || "--"}}</td>
                                            <td class="content">{{item?.userDetails?.email || "--"}}</td>
                                            <!-- <td class="content">{{item.phoneNumber || '--'}}</td> -->
                                            <td class="content">{{(item.createdAt | date:'medium') || "--"}}</td>
                                            <td class="content">{{(item.status | titlecase) || "--" }}</td>
                                            <td class="justify-content-center d-flex">
                                                <button class="btn btn-info ml-2 bt-margin bth" title="View" (click)="viewUser(item._id)">
                                                    <em class="fa fa-eye" aria-hidden="true"></em>
                                                </button>

                                                <button *ngIf="item.status == 'ACTIVE'" class="btn btn-success ml-2 bth" title="Block" data-toggle="modal" data-target="#BlockModal" (click)="getUserId(item._id,item.status)">
                                                    <em class="fa fa-check" aria-hidden="true"></em>
                                                </button>
                                                <button *ngIf="item.status == 'BLOCKED'" class="btn btn-danger ml-2 bth" title="Block"  data-toggle="modal" data-target="#BlockModal" (click)="getUserId(item._id,item.status)">
                                                    <em class="fa fa-ban" aria-hidden="true"></em>
                                                </button>
                                                <button class="btn btn-danger ml-2 bth" title="Delete" data-toggle="modal" data-target="#deleteModal" (click)="getUserId(item?._id)" >
                                                    <em class="fa fa-trash" aria-hidden="true"></em>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr class="text-center" *ngIf="!customerData.length">
                                            <td colspan="7">No Record Found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="custom-pagination mt-2 text-align-end" *ngIf="customerData.length > 1">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                </div>
            </div>
        </div>
    </div>
</main>
<!-- delete user-management modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteModal">
<div class="modal-dialog max-WT-500">
    <form class="change_password">
        <div class="modal-content">
            <div class="modal-header d-block text-center modal-header-custm">
                <h5 class="modal-title d-inline-block">Delete</h5>
            </div>
            <div class="modal-inner-content">
                <div class="modal-body">
                    <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                        <div class="w-100">
                            <p>Are you sure you want to delete this Post?</p>
                            <div class="modal-btn-box">
                                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteUser()">Yes</button>
                                <button type="button" class="btn btn-secondary ml-2" data-dismiss="modal">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
</div>
<div class="modal fade global-modal reset-modal" id="BlockModal">
<div class="modal-dialog max-WT-500">
    <form class="change_password">
        <div class="modal-content">
            <div class="modal-header d-block text-center modal-header-custm">
                <h5 *ngIf="statusString=='BLOCK'" class="modal-title d-inline-block">Block</h5>
                <h5 *ngIf="statusString=='UNBLOCK'" class="modal-title d-inline-block">Unblock</h5>
            </div>
            <div class="modal-inner-content">
                <div class="modal-body">
                    <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                        <div class="w-100">
                            <p *ngIf="statusString=='BLOCK'">Are you sure you want to Block this Post?</p>
                            <p *ngIf="statusString=='UNBLOCK'">Are you sure you want to Unbock this Post?</p>
                            <div class="modal-btn-box">
                                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="blockUnblockUser()">Yes</button>
                                <button type="button" class="btn btn-secondary  ml-2" data-dismiss="modal">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
</div>
<div class="container">
<!-- Trigger the modal with a button -->
<!-- Modal -->
<div class="modal fade" id="myModal-export" role="dialog">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header" style="background: goldenrod;">
                <h5 class="modal-title">Confirmation</h5>
            </div>
            <div class="modal-body">
                <p>The EXCEL export file will be generated for download.</p>
                <p>Disable any popup blockers in your browser to ensure proper download.</p>
                <p>Ok to proceed?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success">OK</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
</div>

